import { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import i18n from "@i18n";

const LanguageContext = createContext({
  preferredLanguage: "en",
});

function ProviderLanguage(props) {
  const preferredLanguage = useSelector((state) => state.preferredLanguage);

  useEffect(() => {
    const isRTL = preferredLanguage === "ar";
    props.isRTLCallback?.(isRTL);
    i18n.changeLanguage(preferredLanguage);
  }, [preferredLanguage]);

  return (
    <LanguageContext.Provider
      value={{
        preferredLanguage,
      }}
    >
      {props.children}
    </LanguageContext.Provider>
  );
}

export default ProviderLanguage;
